export default class Navigation {
    constructor() {
        this.nav = $('#nav-global');

        this.init();
    }

    init() {
        // open nav with main "nav" button
        $('.js-nav-open').on('click', (e) => {
            $(e.currentTarget).removeClass('active');
            $('.js-nav-close').addClass('active');
            // document.body.style.position = 'fixed';

            this.openNav(this.nav);
        });

        // open nav with main "nav" button
        $('.js-nav-close').on('click', (e) => {
            $(e.currentTarget).removeClass('active');
            $('.js-nav-open').addClass('active');
            // document.body.style.position = '';

            this.closeNav(this.nav);
        });
    }

    closeNav(targetNav) {
        console.info('Close Nav!');

        targetNav.removeClass('active');
    }

    openNav(targetNav) {
        console.info('Open Nav!');

        targetNav.addClass('active');
    }

    toggleSubnav(e) {}
}
